import React from 'react';
import {StyleSheet, View} from 'react-native';

const ProgressBar = ({percent = 0}) => {
  if (isNaN(percent) || percent < 0) {
    percent = 0;
  }
  if (percent > 100) {
    percent = 100;
  }
  const emptyValue = 100 - percent;

  return (
    <View style={styles.container}>
      <View style={[styles.fill, {flex: percent}]} />
      <View style={[styles.empty, {flex: emptyValue}]} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    height: 20,
    marginTop: 20,
  },
  fill: {
    backgroundColor: '#FF5722',
    borderTopLeftRadius: 2,
    borderBottomLeftRadius: 2,
  },
  empty: {
    backgroundColor: '#E0EAFF',
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
  },
});

export default ProgressBar;
